const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/admin/audience/$sqid/affiliate.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/settings/admin/audience/$sqid/affiliate")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});